import React, { Component } from 'react';
import { BarElement, CategoryScale, Chart as ChartJS, ChartOptions, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { ChartJsDataModel } from '../../../domain/chart/ChartDomains';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

class BarChartComponent extends Component<Props> {
  public render() {
    const { data, options } = this.props;
    if (options?.maintainAspectRatio) options.maintainAspectRatio = true;
    return <Bar options={options} data={data} />;
  }
}

interface Props {
  data: ChartJsDataModel;
  options?: ChartOptions;
}

export default BarChartComponent;
